import {ThemeProvider} from "@ozon-ai/components/theme.tsx";
import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import App from "./App";
import {TelegramProvider} from "./context/TelegramContext";
import {AuthProvider} from "./context/AuthContext";
import {ThemePreferenceProvider} from "./context/ThemePreferenceContext";
import {AppShell} from "./providers/AppShell";
import "./styles/global.css";
import "./global.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<BrowserRouter>
			<TelegramProvider>
				<ThemeProvider
					defaultTheme="system"
					storageKey="ozon-ai-theme"
				>
					<ThemePreferenceProvider>
						<AppShell>
							<AuthProvider>
								<App/>
							</AuthProvider>
						</AppShell>
					</ThemePreferenceProvider>
				</ThemeProvider>
			</TelegramProvider>
		</BrowserRouter>
	</React.StrictMode>,
);
